<template>
  <div>
    <el-dialog title="选择年份代码" :visible.sync="dialogVisible" :close-on-click-modal="false" width="800px">
      <div style="height: 500px;overflow-y: scroll">
        <el-table
          :data="tableData"
          style="width: 100%;margin-bottom: 20px;"
          row-key="id"
          border
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column prop="account_code" label="科目代码" ></el-table-column>
          <el-table-column prop="account_name" label="科目名称"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <a v-if="!scope.row.children || scope.row.children.length == 0" href="javascript:void(0);" @click="selectItem(scope.row)">选择</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false;callback=undefined">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Http from "../common/Http";

export default {
  name: "SelectYearCode",
  data(){
    return{
      dialogVisible:false,
      callback:null,
      tableData: []
    }
  },
  methods:{
    show(year, callback){
      const that = this;
      that.dialogVisible = true;
      that.callback = callback;
      
      let budgetUrl = window.Glob.budget || "https://budget.gdzawy.com:9001";
      Http.get(budgetUrl + "/admin/budgetSendApi/getYearCode", {year: year}, function (res) {
        if (res.code) {
          that.tableData = that.convertToTree(res.data);
        }
      });
    },

    selectItem(data){
      const that = this;
      typeof that.callback === "function" && that.callback(data);
      that.dialogVisible = false;
      that.callback = undefined;
    },

    convertToTree(data){
      const map = {};
      const tree = [];
      
      // 首先创建所有节点的映射
      data.forEach(item => {
        map[item.account_code] = {
          ...item,
          children: []
        };
      });
      
      // 构建树状结构
      data.forEach(item => {
        if (item.parent_code === "0") {
          // 根节点
          tree.push(map[item.account_code]);
        } else {
          // 子节点
          if (map[item.parent_code]) {
            map[item.parent_code].children.push(map[item.account_code]);
          }
        }
      });
      
      return tree;
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Admin/Flow/components/SelectYearCode.vue